import React from "react";
import FileUpload from "../../Molecule/Inputs/FileUpload/FileUpload";

const Image = ({ customComponent, onChange, isActive, isDisabled }) => {
	const addImage = href => {
		if (onChange) onChange(href);
	};

	return (
		<>
			<button
				className={`editor-menu-item${isActive ? " is-active" : ""}`}
				title="Add Image"
				type="button"
				disabled={isDisabled}
			>
				<FileUpload onChange={addImage} moduleNumber={4} noCrop>
					{customComponent ? customComponent : <i className="fas fa-image" />}
				</FileUpload>
			</button>
		</>
	);
};

export default Image;
